(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1800],{

/***/ 7818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MerchantSite; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _molecules_PreparingMerchantSite__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60719);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var MerchantSite = function MerchantSite(_ref) {
  var children = _ref.children,
      isUnPublished = _ref.isUnPublished,
      isMerchantInfoExist = _ref.isMerchantInfoExist,
      _ref$isProtected = _ref.isProtected,
      isProtected = _ref$isProtected === void 0 ? false : _ref$isProtected,
      protectedElement = _ref.protectedElement,
      merchantPublicId = _ref.merchantPublicId,
      logoImage = _ref.logoImage,
      isCoubicApp = _ref.isCoubicApp;
  if (isUnPublished && !isMerchantInfoExist) return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_molecules_PreparingMerchantSite__WEBPACK_IMPORTED_MODULE_1__/* .PreparingMerchantSite */ .B, {
    isCoubicApp: isCoubicApp,
    logoImage: logoImage,
    merchantPublicId: merchantPublicId
  });
  if (isProtected) return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: protectedElement
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: children
  });
};

/***/ }),

/***/ 45623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layouts_MerchantGlobalFooter; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/layouts/MerchantGlobalFooter/index.module.scss
var index_module = __webpack_require__(37178);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./src/atoms/buttons/Button/index.tsx
var Button = __webpack_require__(48413);
// EXTERNAL MODULE: ./src/components/layouts/common/ServiceFooterAccordion.tsx
var ServiceFooterAccordion = __webpack_require__(16784);
// EXTERNAL MODULE: ./src/components/layouts/common/ServiceFooterLogo.tsx
var ServiceFooterLogo = __webpack_require__(53447);
// EXTERNAL MODULE: ./src/components/layouts/common/ServiceFooterSectionBody.tsx + 1 modules
var ServiceFooterSectionBody = __webpack_require__(47544);
// EXTERNAL MODULE: ./src/components/layouts/MerchantGlobalFooter/ServiceFooter.module.scss
var ServiceFooter_module = __webpack_require__(95663);
var ServiceFooter_module_default = /*#__PURE__*/__webpack_require__.n(ServiceFooter_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/layouts/MerchantGlobalFooter/ServiceFooter.tsx










var ServiceFooter = function ServiceFooter() {
  var intl = (0,useIntl/* default */.Z)();
  var intlPref = 'components.common.layouts.merchantGlobalFooter.serviceFooter.';
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (ServiceFooter_module_default()).ServiceFooter,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (ServiceFooter_module_default()).ServiceFooter__Inner,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (ServiceFooter_module_default()).ServiceFooter__LinkSection,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ServiceFooterLogo/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.ZP, {
          buttonSize: Button/* ButtonSize.Medium */.qE.Medium,
          buttonColor: Button/* ButtonColor.Biz */.rp.Biz,
          className_Deprecated: (ServiceFooter_module_default()).ServiceFooter__Button,
          href: "https://stores.jp/reserve",
          children: intl.formatMessage({
            id: intlPref + 'buttons.startTrial'
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ServiceFooterAccordion/* default */.Z, {
        name: "footer-business",
        copy: intl.formatMessage({
          id: intlPref + 'copies.business'
        }),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ServiceFooterSectionBody/* default */.Z, {
          rows: [{
            heading: intl.formatMessage({
              id: intlPref + 'headings.service'
            }),
            links: [{
              url: 'https://stores.jp/reserve',
              text: intl.formatMessage({
                id: intlPref + 'links.business'
              })
            }, {
              url: '/inquiry',
              text: intl.formatMessage({
                id: intlPref + 'links.inquiry'
              })
            }, {
              url: 'https://go.coubic.com/doc_feature.html',
              text: intl.formatMessage({
                id: intlPref + 'links.requestDoc'
              })
            }, {
              url: 'https://go.coubic.com/movie_demo.html',
              text: intl.formatMessage({
                id: intlPref + 'links.demoMovie'
              })
            }, {
              url: 'https://stores.jp/reserve/features',
              text: intl.formatMessage({
                id: intlPref + 'links.features'
              })
            }, {
              url: 'https://stores.jp/reserve/advantages',
              text: intl.formatMessage({
                id: intlPref + 'links.advantages'
              })
            }, {
              url: 'https://stores.jp/reserve/integrations',
              text: intl.formatMessage({
                id: intlPref + 'links.integrations'
              })
            }, {
              url: 'https://stores.jp/reserve/cases',
              text: intl.formatMessage({
                id: intlPref + 'links.cases'
              })
            }, {
              url: 'https://stores.jp/reserve/pricing',
              text: intl.formatMessage({
                id: intlPref + 'links.pricing'
              })
            }, {
              url: 'https://stores.jp/reserve/faq',
              text: intl.formatMessage({
                id: intlPref + 'links.faq'
              })
            } // # リソース不足のため一時的にクローズする see: https://github.com/heyinc/rsv-issues/issues/16266
            // {
            //   url: '/partnership/become_partner',
            //   text: intl.formatMessage({
            //     id: intlPref + 'links.partners',
            //   }),
            // },
            ]
          }, {
            heading: intl.formatMessage({
              id: intlPref + 'headings.bizCategory'
            }),
            links: [// TODO: merchant_categoryがpath情報もってない
            {
              url: 'https://stores.jp/reserve/categories/yoga',
              text: intl.formatMessage({
                id: intlPref + 'links.yoga'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/massage_salons',
              text: intl.formatMessage({
                id: intlPref + 'links.massage'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/fitness_school',
              text: intl.formatMessage({
                id: intlPref + 'links.fitness_school'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/online_lessons',
              text: intl.formatMessage({
                id: intlPref + 'links.online_lessons'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/hair_salons',
              text: intl.formatMessage({
                id: intlPref + 'links.hairsalons'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/nail_salons',
              text: intl.formatMessage({
                id: intlPref + 'links.nailsalons'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/spaces',
              text: intl.formatMessage({
                id: intlPref + 'links.spaces'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/exhibitions',
              text: intl.formatMessage({
                id: intlPref + 'links.exhibitions'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/lessons',
              text: intl.formatMessage({
                id: intlPref + 'links.classes'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/seminar',
              text: intl.formatMessage({
                id: intlPref + 'links.seminar'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/recruiting',
              text: intl.formatMessage({
                id: intlPref + 'links.recruiting'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/communities',
              text: intl.formatMessage({
                id: intlPref + 'links.community'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/events',
              text: intl.formatMessage({
                id: intlPref + 'links.events'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/tourism',
              text: intl.formatMessage({
                id: intlPref + 'links.tourism'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/experts',
              text: intl.formatMessage({
                id: intlPref + 'links.experts'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/cooking_lessons',
              text: intl.formatMessage({
                id: intlPref + 'links.cooking_class'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/golf_lessons',
              text: intl.formatMessage({
                id: intlPref + 'links.golf_lesson'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/language_lessons',
              text: intl.formatMessage({
                id: intlPref + 'links.language_school'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/pc_lessons',
              text: intl.formatMessage({
                id: intlPref + 'links.pc_class'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/sports_lessons',
              text: intl.formatMessage({
                id: intlPref + 'links.sports_lesson'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/others',
              text: intl.formatMessage({
                id: intlPref + 'links.other'
              })
            }]
          }]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ServiceFooterAccordion/* default */.Z, {
        name: 'footer-company',
        copy: intl.formatMessage({
          id: intlPref + 'copies.company'
        }),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ServiceFooterSectionBody/* default */.Z, {
          rows: [{
            heading: intl.formatMessage({
              id: intlPref + 'headings.company'
            }),
            links: [{
              url: 'https://www.corp.coubic.com/',
              text: intl.formatMessage({
                id: intlPref + 'links.company'
              })
            }, {
              url: 'https://jobs.st.inc',
              text: intl.formatMessage({
                id: intlPref + 'links.recruit'
              })
            }, {
              url: 'https://www.corp.coubic.com/news',
              text: intl.formatMessage({
                id: intlPref + 'links.companyNews'
              })
            }]
          }, {
            heading: intl.formatMessage({
              id: intlPref + 'headings.media'
            }),
            links: [{
              url: '/blog',
              text: intl.formatMessage({
                id: intlPref + 'links.officialBlog'
              })
            }, {
              url: 'https://blog.coubic.com/',
              text: 'ビズシル'
            }]
          }, {
            heading: intl.formatMessage({
              id: intlPref + 'headings.stores'
            }),
            links: [{
              url: 'https://stores.jp/ec',
              text: intl.formatMessage({
                id: intlPref + 'links.storesEC'
              })
            }, {
              url: 'https://coiney.com',
              text: intl.formatMessage({
                id: intlPref + 'links.storesPayments'
              })
            }, {
              url: 'https://stores.jp/regi',
              text: intl.formatMessage({
                id: intlPref + 'links.storesRegi'
              })
            }]
          }]
        })
      })]
    })
  });
};

/* harmony default export */ var MerchantGlobalFooter_ServiceFooter = (ServiceFooter);
// EXTERNAL MODULE: ./src/contexts/LocaleContext.tsx + 9 modules
var LocaleContext = __webpack_require__(85969);
// EXTERNAL MODULE: ./src/components/layouts/MerchantGlobalFooter/SiteFooter.module.scss
var SiteFooter_module = __webpack_require__(7787);
var SiteFooter_module_default = /*#__PURE__*/__webpack_require__.n(SiteFooter_module);
;// CONCATENATED MODULE: ./src/components/layouts/MerchantGlobalFooter/SiteFooter.tsx







var SiteFooter = function SiteFooter() {
  var intl = (0,useIntl/* default */.Z)();
  var localeCtx = react.useContext(LocaleContext/* LocaleContext */.RD);
  var intlPref = 'components.common.layouts.merchantGlobalFooter.siteFooter.';
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (SiteFooter_module_default()).SiteFooter,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (SiteFooter_module_default()).SiteFooter__Inner,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (SiteFooter_module_default()).SiteFooter__Copyright,
        children: "STORES, Inc."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (SiteFooter_module_default()).SiteFooter__Links,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "/terms",
          className: (SiteFooter_module_default()).SiteFooter__Link,
          children: intl.formatMessage({
            id: intlPref + 'links.terms'
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://id.stores.jp/privacy_policy",
          className: (SiteFooter_module_default()).SiteFooter__Link,
          children: intl.formatMessage({
            id: intlPref + 'links.policyForMerchant'
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://stores.jp/reserve/privacy",
          className: (SiteFooter_module_default()).SiteFooter__Link,
          children: intl.formatMessage({
            id: intlPref + 'links.policyForEndUser'
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "/intl/ja/legal_notice",
          className: (SiteFooter_module_default()).SiteFooter__Link,
          children: intl.formatMessage({
            id: intlPref + 'links.sct'
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (SiteFooter_module_default()).SiteFooter__Language,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          children: [intl.formatMessage({
            id: intlPref + 'language'
          }), ": "]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("select", {
          className: (SiteFooter_module_default()).SiteFooter__LanguageSelect,
          onChange: function onChange(e) {
            localeCtx.changeLocale(e.target.value);
          },
          value: localeCtx.currentLocale,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("option", {
            value: "ja",
            children: "\u65E5\u672C\u8A9E"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
            value: "en",
            children: "English"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
            value: "ko",
            children: "\uD55C\uAD6D\uC5B4"
          })]
        })]
      })]
    })
  });
};

/* harmony default export */ var MerchantGlobalFooter_SiteFooter = (SiteFooter);
;// CONCATENATED MODULE: ./src/components/layouts/MerchantGlobalFooter/index.tsx







var MerchantGlobalFooter = function MerchantGlobalFooter(props) {
  var hideBlandContent = props.hideBlandContent;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("footer", {
    className: (index_module_default()).MerchantGlobalFooter,
    children: [!hideBlandContent && /*#__PURE__*/(0,jsx_runtime.jsx)(MerchantGlobalFooter_ServiceFooter, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(MerchantGlobalFooter_SiteFooter, {})]
  });
};

MerchantGlobalFooter.defaultProps = {
  hideBlandContent: true
};
/* harmony default export */ var layouts_MerchantGlobalFooter = (MerchantGlobalFooter);

/***/ }),

/***/ 84915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ COUBIC_ORIGIN; },
  "Z": function() { return /* binding */ layouts_MetaTags; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./src/utils/gtag.ts
var gtag = __webpack_require__(7788);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/utils/GTMUtils.tsx






var GTMContainer = function GTMContainer() {
  return (
    /*#__PURE__*/
    // NOTE: gtag.js に渡す data layer と区別するため、名称を gtmDataLayer とする
    _jsx(_Fragment, {
      children: Object.values(GTM_CONFIGS).map(function (config) {
        var script = "\n      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});\n      var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;\n      j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl+'&gtm_auth=".concat(config.auth, "&gtm_preview=").concat(config.preview, "&gtm_cookies_win=x';\n      f.parentNode.insertBefore(j,f);})(window,document,'script','gtmDataLayer','").concat(config.containerId, "');\n      ");
        return /*#__PURE__*/_jsx("script", {
          dangerouslySetInnerHTML: {
            __html: script
          }
        });
      })
    })
  );
};
var GTMConfig = function GTMConfig() {
  var script = "\n    window.gtmDataLayer = window.gtmDataLayer || [];\n    function gtag(){gtmDataLayer.push(arguments);}\n  ";
  return /*#__PURE__*/_jsx("script", {
    dangerouslySetInnerHTML: {
      __html: script
    }
  });
};
var GTMNoScript = function GTMNoScript() {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: Object.values(GTM_CONFIGS).map(function (config) {
      return /*#__PURE__*/_jsx("noscript", {
        children: /*#__PURE__*/_jsx("iframe", {
          src: "https://www.googletagmanager.com/ns.html?id=".concat(config.containerId, "&gtm_auth=").concat(config.auth, "&gtm_preview=").concat(config.preview, "&gtm_cookies_win=x"),
          height: 0,
          width: 0,
          style: {
            display: 'none',
            visibility: 'hidden'
          }
        })
      });
    })
  });
};
var GA4Tag = function GA4Tag(_ref) {
  var pageTitle = _ref.pageTitle,
      googleAnalyticsFourTrackingId = _ref.googleAnalyticsFourTrackingId;
  react.useEffect(function () {
    // NOTE: ページタイトルを戻り値のjsに埋め込む場合はエスケープが必要なため、グローバル定数に設定して直接読み込ませる
    window.ga4PageTitle = pageTitle;
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
      src: "https://www.googletagmanager.com/gtag/js?id=".concat(googleAnalyticsFourTrackingId)
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
      id: "google-analytics-four-container",
      children: "\n          window.dataLayer = window.dataLayer || [];\n          function ga4tag(){dataLayer.push(arguments);}\n          const ga4ConfigParams = {page_title:window.ga4PageTitle}\n\n          const href = window.location.href;\n          const url = new URL(href);\n\n          const clientId = url.searchParams.get(\"gaClientId\");\n          const sessionId = url.searchParams.get(\"gaSessionId\");\n          if (clientId) { ga4ConfigParams['client_id'] = clientId; }\n          if (sessionId) { ga4ConfigParams['session_id'] = sessionId; }\n\n          ga4tag('js', new Date());\n          ga4tag('config','".concat(googleAnalyticsFourTrackingId, "',ga4ConfigParams);\n        ")
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/layouts/MetaTags.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







// 環境ごとに変わるものだが、本番環境以外では重要ではないので定数で書いている
var COUBIC_ORIGIN = 'https://coubic.com';

var MetaTags = function MetaTags(initProps) {
  var defaultProps = {
    title: 'Coubic (クービック) | 人気サービスの検索・予約サイト',
    description: '月間250万人以上が利用する検索・予約サイト「クービック」では、フィットネスジム・ヨガ・ピラティス・リラクなど様々なサービスを簡単に予約できます。事業者様は無料でサービス情報を掲載できると共に、180以上の業種に対応した予約システムを7日間無料でご利用頂けます。',
    thumbnailUrl: 'https://d3jf92lm1e7l6.cloudfront.net/images/shared/merchant_categories/4/600x400.png',
    keywords: '予約, クービック',
    currentUrl: COUBIC_ORIGIN,
    noIndex: false,
    opgDisabled: false
  };

  var _defaultProps$initPro = _objectSpread(_objectSpread({}, defaultProps), initProps),
      title = _defaultProps$initPro.title,
      description = _defaultProps$initPro.description,
      thumbnailUrl = _defaultProps$initPro.thumbnailUrl,
      keywords = _defaultProps$initPro.keywords,
      currentUrl = _defaultProps$initPro.currentUrl,
      pagination = _defaultProps$initPro.pagination,
      noIndex = _defaultProps$initPro.noIndex,
      opgDisabled = _defaultProps$initPro.opgDisabled,
      googleAnalyticsFourTrackingId = _defaultProps$initPro.googleAnalyticsFourTrackingId,
      faviconImageUrl = _defaultProps$initPro.faviconImageUrl;

  var titleWithSuffix = "".concat(title).concat(title !== defaultProps.title ? ' | Coubic' : '');
  var canonicalUrl = currentUrl.replace(/\?page=1$/g, '').replace(/\/\?/g, '?').replace(/\/$/, '');
  var baseUrl = currentUrl.replace(/\?.*$/, '');
  var robotsContent = noIndex ? 'noindex, follow, noarchive' : 'noarchive';
  var escapedDescription = description === null || description === void 0 ? void 0 : description.replace(/\s+/g, '');
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [googleAnalyticsFourTrackingId && /*#__PURE__*/(0,jsx_runtime.jsx)(GA4Tag, {
      googleAnalyticsFourTrackingId: googleAnalyticsFourTrackingId,
      pageTitle: titleWithSuffix
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: titleWithSuffix
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        content: robotsContent,
        name: "robots"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "keywords",
        content: keywords
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: escapedDescription
      }), !opgDisabled && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          property: "og:site_name",
          content: titleWithSuffix
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          property: "og:type",
          content: "website"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          property: "og:description",
          content: escapedDescription
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          property: "og:image",
          content: thumbnailUrl
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          name: "twitter:card",
          content: "summary"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          name: "twitter:site",
          content: "@coubic"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          name: "twitter:title",
          content: titleWithSuffix
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          name: "twitter:description",
          content: escapedDescription
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          name: "twitter:image",
          content: thumbnailUrl
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        href: canonicalUrl,
        rel: "canonical"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "icon",
        type: "imae/x-icon",
        href: faviconImageUrl !== null && faviconImageUrl !== void 0 ? faviconImageUrl : '/static/favicon.ico'
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "shortcut icon",
        href: faviconImageUrl !== null && faviconImageUrl !== void 0 ? faviconImageUrl : '/static/favicon.ico'
      }), pagination && pagination.currentPage < pagination.totalPages && /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "next",
        href: "".concat(baseUrl, "?page=").concat(pagination.currentPage + 1)
      }), pagination && pagination.currentPage !== 1 && /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "prev",
        href: "".concat(baseUrl, "?page=").concat(pagination.currentPage - 1)
      })]
    })]
  });
};

/* harmony default export */ var layouts_MetaTags = (MetaTags);

/***/ }),

/***/ 60719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ PreparingMerchantSite; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91973);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_layouts_GlobalNav_GlobalNav__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29836);
/* harmony import */ var _components_layouts_MerchantGlobalFooter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45623);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);



 // @svgr/webpackを使用してsvgをReactコンポーネントとして読み込みたいが、現状raw-loaderでdangerouslySetInnerHTMLしていて影響範囲が大きいのでベタがきしている




var Icon = function Icon() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("svg", {
    width: "216",
    height: "157",
    viewBox: "0 0 216 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("path", {
      d: "M170.5 105.9C158.6 105.9 148.7 102.4 141.4 95.8001C133.8 97.4001 125.6 97.9001 117.6 96.7001C112.2 99.2001 105.7 101.1 97.9999 102H97.8999C89.2999 103 73.4999 104.8 60.0999 99.5001C56.8999 100.9 53.5999 102 50.0999 102.8C38.4999 105.4 26.9999 103.6 17.8999 97.8001C0.299942 86.4001 -3.20006 62.3001 2.49994 44.4001C4.99994 36.5001 13.4999 32.2001 21.3999 34.7001C29.2999 37.2001 33.5999 45.7001 31.0999 53.6001C28.6999 61.1001 30.0999 70.0001 34.1999 72.6001C35.5999 73.5001 37.1999 73.9001 38.6999 74.0001C34.0999 53.8001 44.1999 30.1001 51.4999 18.4001C54.6999 13.3001 66.2999 -3.09987 81.0999 1.30013C84.4999 2.30013 91.5999 5.60013 93.5999 15.9001C98.3999 9.60013 106.2 2.00013 116.4 0.300129C125.9 -1.19987 134.8 2.90013 140.2 11.5001C140.9 12.6001 141.5 13.8001 142.1 15.0001C143 13.9001 143.9 12.8001 144.8 11.8001C156.8 -0.799871 168.2 1.70013 172.5 3.40013C182.1 7.10013 187.8 17.2001 188.2 30.9001C188.6 45.8001 184.1 62.9001 174.8 75.6001C175.4 75.5001 176 75.4001 176.6 75.3001C181.5 74.5001 186.8 71.7001 189.8 68.4001C195.4 62.3001 204.8 61.8001 211 67.3001C217.1 72.9001 217.6 82.3001 212.1 88.5001C204.5 96.9001 193.1 103 181.5 104.9C177.7 105.6 174 105.9 170.5 105.9ZM116.6 35.2001C113.5 39.5001 110.3 45.9001 109.5 52.7001C108.7 59.8001 111.1 62.2001 112.2 63.1001C113.1 61.5001 113.7 59.6001 114.2 57.7001C116.2 48.6001 116.8 40.7001 116.6 35.2001Z",
      fill: "#EAF0F6"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("path", {
      d: "M159.6 156.8H56.3998C52.4998 156.8 49.2998 153.6 49.2998 149.7V148.6C49.2998 144.7 52.4998 141.5 56.3998 141.5H159.5C163.4 141.5 166.6 144.7 166.6 148.6V149.7C166.6 153.6 163.5 156.8 159.6 156.8Z",
      fill: "#4F667D"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("path", {
      d: "M100.3 24.1L66 141.6H150.2L115.9 24.1C113.6 16.3 102.6 16.3 100.3 24.1Z",
      fill: "#4F667D"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("mask", {
      id: "mask0_3521_21455",
      maskUnits: "userSpaceOnUse",
      x: "66",
      y: "18",
      width: "85",
      height: "124",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("path", {
        d: "M100.3 24.1L66 141.6H150.2L115.9 24.1C113.6 16.3 102.6 16.3 100.3 24.1Z",
        fill: "#4F667D"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("g", {
      mask: "url(#mask0_3521_21455)",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("path", {
        d: "M171.4 36.1998L50.7998 67.9998V50.0998L171.4 18.2998V36.1998Z",
        fill: "#C2D1E0"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("path", {
        d: "M171.4 71.6998L50.7998 103.5V85.5998L171.4 53.7998V71.6998Z",
        fill: "#C2D1E0"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("path", {
        d: "M171.4 107.3L50.7998 139V121.1L171.4 89.2998V107.3Z",
        fill: "#C2D1E0"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("path", {
      d: "M75.3998 141.6H140.6",
      stroke: "#002E4E"
    })]
  });
};

var PreparingMerchantSite = function PreparingMerchantSite(_ref) {
  var isCoubicApp = _ref.isCoubicApp,
      logoImage = _ref.logoImage,
      merchantPublicId = _ref.merchantPublicId;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().base_layout),
    children: [!isCoubicApp && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_layouts_GlobalNav_GlobalNav__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      logoImage: logoImage,
      merchantPublicId: merchantPublicId
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().container),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().icon),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Icon, {})
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().preparing_text),
        children: "\u4E88\u7D04\u30B5\u30A4\u30C8\u306F\u6E96\u5099\u4E2D\u3067\u3059"
      })]
    }), !isCoubicApp && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().footer),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_layouts_MerchantGlobalFooter__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
    })]
  });
};

/***/ }),

/***/ 7788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h5": function() { return /* binding */ bookingEvent; },
/* harmony export */   "mG": function() { return /* binding */ purchaseEvent; }
/* harmony export */ });
/* unused harmony export GTM_CONFIGS */
var googleTagEnv = "production";
var GTM_CONFIGS = function () {
  switch (googleTagEnv) {
    case 'production':
      return {
        coubicFrontend: {
          auth: 'CXsKrbmeizWaaDt3OQhenA',
          containerId: 'GTM-MHRX774',
          preview: 'env-2'
        },
        coubicFrontend2: {
          auth: 'ppK0fcQWXybVZcdICBq2MA',
          containerId: 'GTM-WS64FTM',
          preview: 'env-2'
        }
      };

    case 'staging':
      return {
        coubicFrontendStaging: {
          auth: '60N0lrbFuaMSjWJtbZuzxw',
          containerId: 'GTM-PNBPHKZ',
          preview: 'env-2'
        },
        coubicFrontendStaging2: {
          auth: 'qj-_qgA8YLhy5RXC7R7BsA',
          containerId: 'GTM-TST7Z7M',
          preview: 'env-2'
        }
      };

    default:
      return {};
  }
}();
var bookingEvent = function bookingEvent(_ref) {
  var step = _ref.step,
      resourcePublicId = _ref.resourcePublicId,
      reservationPublicId = _ref.reservationPublicId;

  if (window.gtag) {
    window.gtag('event', 'booking_rendered', {
      booking_step: step,
      res_id: resourcePublicId,
      rv_id: reservationPublicId
    });
  }

  if (window.ga4tag) {
    var uri = new URL(window.location.href); // GA4 用のカスタムイベントのキー名称はマーチャントのオーナーが
    // アナリティクス管理の設定時に見ることのあるものなので、resourceという名前の露出を避けた名称にしています

    window.ga4tag('event', 'booking', {
      booking_step: step,
      reservation_page_id: resourcePublicId,
      reservation_id: reservationPublicId,
      URL: uri.href
    });
  }
};
var purchaseEvent = function purchaseEvent(_ref2) {
  var step = _ref2.step,
      productPublicId = _ref2.productPublicId,
      customerPublicId = _ref2.customerPublicId;

  if (window.gtag) {
    window.gtag('event', 'purchase_rendered', {
      purchase_step: step,
      product_id: productPublicId,
      customer_id: customerPublicId
    });
  }

  if (window.ga4tag) {
    var uri = new URL(window.location.href);
    window.ga4tag('event', 'purchase', {
      purchase_step: step,
      product_id: productPublicId,
      customer_id: customerPublicId,
      URL: uri.href
    });
  }
};

/***/ }),

/***/ 95663:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ServiceFooter":"ServiceFooter_ServiceFooter__SRtU6","ServiceFooter__Inner":"ServiceFooter_ServiceFooter__Inner__ADpFi","ServiceFooter__LinkSection":"ServiceFooter_ServiceFooter__LinkSection__kQMHd","ServiceFooter__StoreBadge":"ServiceFooter_ServiceFooter__StoreBadge__HghRY","ServiceFooter__StoreBadgeImage":"ServiceFooter_ServiceFooter__StoreBadgeImage__0r8zj","ServiceFooter__Button":"ServiceFooter_ServiceFooter__Button__qPHMT"};

/***/ }),

/***/ 7787:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"SiteFooter":"SiteFooter_SiteFooter__UNKHn","SiteFooter__Inner":"SiteFooter_SiteFooter__Inner__tp_Tk","SiteFooter__Copyright":"SiteFooter_SiteFooter__Copyright__ivK_D","SiteFooter__Links":"SiteFooter_SiteFooter__Links__50FGz","SiteFooter__Link":"SiteFooter_SiteFooter__Link__rdJVP","SiteFooter__Language":"SiteFooter_SiteFooter__Language__1JdYJ","SiteFooter__LanguageSelect":"SiteFooter_SiteFooter__LanguageSelect___pOWJ"};

/***/ }),

/***/ 37178:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"MerchantGlobalFooter":"MerchantGlobalFooter_MerchantGlobalFooter__plrC_"};

/***/ }),

/***/ 91973:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"base_layout":"style_base_layout__MDytW","container":"style_container__MNEsM","icon":"style_icon__89D38","preparing_text":"style_preparing_text__gVH4p","footer":"style_footer__fv2LO"};

/***/ })

}]);